var $ = require('jquery');

var $form = $('#forget-password');
console.log($form);
var $error = $('#error');
var $thankYou = $('#thankYou');

$form.children('form').on('submit', function(event) {
  event.preventDefault();

  $.ajax({
    method:   'POST',
    dataType: 'json',
    success:  requestReceived,
    data:     {
      email:    $form.find('input[name="email"]').val(),
      nonce:    $form.find('input[name="nonce"]').val(),
      zip:    $form.find('input[name="zip"]').val(),
    }
  });
});

function requestReceived(data, status, request) {
  if ( data.status ) {
    $form.remove();
    $error.remove();
    $thankYou.show();
  } else {
    $error.html('<p>' + data.msg + '</p>');

    for (var field in data.fields) {
      $error.append('<p>' + data.fields[field] + '</p>');
    }

    $error.show();

    var scrollToElement = $("#error");
    $(window).scrollTop( scrollToElement.offset().top);
  }
}



//////////////////
// WEBPACK FOOTER
// ./views/js/forget-password.js
// module id = 16
// module chunks = 6